import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  tag: 'Pronto in 5 minuti',
  icon: '⚡',
  title: "Lezioni Pronte all'Uso",
  desc: 'Dalla morfosintassi alla Maturità, tutto strutturato per ragazzi dagli 11 ai 19 anni. Apri il file e sei pronto.'
}, {
  tag: '6 Tomi Risolti',
  icon: '📚',
  title: 'Percorso Completo di Letteratura',
  desc: "Ogni tomo copre un'epoca letteraria completa con analisi testuali, schede e attività già pronte. Risparmia ore di ricerca manuale."
}, {
  tag: 'Slide LIM incluse',
  icon: '🖥️',
  title: 'Supporto Visivo per la LIM',
  desc: 'Slide grafiche ad alto impatto pronte da proiettare: apri, mostra, insegna i classici italiani in modo coinvolgente e moderno.'
}, {
  tag: 'Conforme MIM',
  icon: '🎓',
  title: 'Metodologia di Eccellenza',
  desc: 'Un sistema che garantisce la copertura completa del programma MIM con la metodologia KITONLINE™.'
}, {
  tag: 'DSA e BES',
  icon: '🧩',
  title: 'Didattica Inclusiva',
  desc: 'Materiali differenziati per livello Base, Intermedio e Avanzato con kit dedicato DSA e BES conforme alla Legge 170/2010.'
}, {
  tag: 'Pronto da stampare',
  icon: '📝',
  title: 'Verifiche e Griglie',
  desc: 'Verifiche modulari con rubriche di valutazione già conformi alle linee guida ministeriali per ogni tipologia testuale.'
}];
export function Benefits() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-23">
          Tutto incluso nel Kit
        </p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-3 text-brand-cream" data-id="element-24">
          Cosa otterrai con{' '}
          <span className="text-brand-orange" data-id="element-25">Lettere Pronte</span>
        </motion.h2>
        <p className="text-center text-gray-400 text-sm mb-8 max-w-2xl mx-auto" data-id="element-26">
          6 vantaggi concreti che trasformano il modo in cui prepari, insegni e
          valuti Lingua e Letteratura.
        </p>

        <div className="grid grid-cols-1 gap-4" data-id="element-27">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-brand-orange/20 p-6 rounded-2xl hover:border-brand-orange/50 transition-all" data-id="element-28">
              <div className="inline-block bg-brand-orange/10 border border-brand-orange/30 text-brand-orange text-[10px] font-black px-2.5 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-29">
                {b.tag}
              </div>
              <div className="flex items-start gap-3 mb-2" data-id="element-30">
                <span className="text-3xl" data-id="element-31">{b.icon}</span>
                <h3 className="text-lg sm:text-xl font-bold text-brand-cream leading-tight" data-id="element-32">
                  {b.title}
                </h3>
              </div>
              <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-33">
                {b.desc}
              </p>
            </motion.div>)}
        </div>

        <p className="text-center mt-8 text-brand-gold font-bold text-base sm:text-lg" data-id="element-34">
          + 4 Bonus esclusivi del valore di 87€ inclusi
        </p>
      </div>
    </section>;
}